import React from "react";

export default function DateOption({ dateOption, handleDateOptionChange }) {
    return (
        <div className="flex items-center gap-2 text-sm sm:text-base mb-2 cursor-default">
            <label htmlFor="dateOptions" className="shrink-0">Basée sur la date</label>
            <select
                name="dateOptions"
                id="dateOptions"
                className="dropdown-filter select max-w-56"
                value={dateOption}
                onChange={handleDateOptionChange}
                aria-label="Sélectionnez la base de calcul pour la date"
            >
                <option value="lastPeriod">des dernières règles</option>
                <option value="startPregnancy">du début de grossesse</option>
                <option value="endPregnancy">du terme de la grossesse</option>
            </select>
        </div>
    )
}